import React from "react";
import "./Platform.scss";
import Footer from "../common/Footer/NewFooter";
import Header from "../common/Header/Header";
import Conversion from "../Home/Conversion";
import PlatformLanding from "./PlatformLanding";
import BestInTech from "./BestInTech";
import {conversionDesc} from "../Home/Home";


const Platform = () => {
  return (
    <div id='platform'>
      <Header />
      <PlatformLanding />
      <BestInTech />
      <Conversion className="customize-converison" title={platform_conversion_title} desc={platfrom_conversion_desc} type="video" videoURL={"https://dashboard.causalfunnel.com/assets/causalfunnel_explainer.mp4"} />
      <Footer />
    </div>
  );
};
export default Platform;


export const platform_conversion_title = "See the conversion improvement we delivered for our customers";
export const platfrom_conversion_desc = conversionDesc;
// export const platfrom_conversion_desc = `CausalFunnel technology actively drives your visitors 
// along the conversion funnel with persona and intent prediction nudges. 
// Our technology works even if the visitor comes back after their 
// cookies have been cleared (Apple clears cookies in 1 to 7 days). 
// The platform continuously boosts your conversion during various buying stages of a visitor.`;
